import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getValue'
})
export class GetValuePipe implements PipeTransform {
  transform(value: object, paths: string[]): any {
    // return paths.reduce(() => {});
  }
}
